







import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

import {LatLon} from './models/LatLon'
import NMapChildren from './NMapChildren.vue'

@Component({
  components: {},
})
export default class NMapMarker extends NMapChildren {
  @Prop() public position!: LatLon
  @Prop() public icon!: string

  public init() {
    this.item = this.getNMap().providerInstance.addMarker(
      this.position,
      this.icon,
      this.$slots.default ? this.$slots.default[0].elm : null,
      this.$listeners && this.$listeners.click ? () => {
        this.$emit('click')
      } : () => {
      }
    )
  }

  @Watch('position')
  public valueChanged(newValue: any, oldValue: any) {
    if (!this.isReady()) return; // introdotto perchè se la position cambia prima dell'inizializzazione del componente abbiamo errori di inizializzazione tipo L undefinied
    // console.log('test')
    this.clean()
    this.$nextTick(() => {
      this.init()
      this.getNMap().pan(this.position) // in modo da "centrare" la mappa nella nuova position
    })
  }
}
